module.exports = __webpack_public_path__ + "img/honor.eb37c0c3.png";